import { Button } from "primereact/button";
import "./LocationInlineEditActions.scss";

interface LocationInlineEditActionsProps {
    visible: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    confirmTooltip?: string;
    cancelTooltip?: string;
}

export default function LocationInlineEditActions({
    visible,
    onConfirm,
    onCancel,
    confirmTooltip = "Confirmar cambios",
    cancelTooltip = "Cancelar cambios",
}: Readonly<LocationInlineEditActionsProps>) {
    if (!visible) return null;

    return (
        <div className="location-inline-edit-actions">
            <Button
                type="button"
                rounded
                outlined
                severity="success"
                icon="pi pi-check"
                className="location-inline-edit-actions__confirm"
                tooltip={confirmTooltip}
                tooltipOptions={{ position: "top" }}
                onClick={onConfirm}
                aria-label={confirmTooltip}
            />
            <Button
                type="button"
                rounded
                outlined
                severity="danger"
                icon="pi pi-times"
                className="location-inline-edit-actions__cancel"
                tooltip={cancelTooltip}
                tooltipOptions={{ position: "top" }}
                onClick={onCancel}
                aria-label={cancelTooltip}
            />
        </div>
    );
}
